import React from "react";

const Rounds = (prop) => {
  return (
    <div className="rounds-count">
      <h4 className="round">Round {prop.rounds}</h4>;
    </div>
  );
};

export default Rounds;
